"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toggleGalleryLike } from "@/features/gallery/actions"

export function useToggleGalleryLike() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: toggleGalleryLike,
    onSuccess: (result) => {
      if (!result.success) return
      // Invalidate all gallery feeds to reflect updated like counts
      queryClient.invalidateQueries({ queryKey: ["gallery", "feed"] })
    },
  })
}
